var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPasswordHide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.002,
    height: 11.43,
    viewBox: "0 0 21.002 11.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_View_2462850",
    transform: "translate(-5 -25.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63805",
    "data-name": "Path 63805",
    d: "M15.5,25.51c-5.024,0-9.237,4.155-10.37,5.378a.493.493,0,0,0,0,.671c1.132,1.224,5.346,5.381,10.37,5.381s9.237-4.156,10.37-5.381a.493.493,0,0,0,0-.671C24.738,29.665,20.525,25.51,15.5,25.51Zm0,9.378a3.663,3.663,0,1,1,3.663-3.663A3.663,3.663,0,0,1,15.5,34.888Z",
    transform: "translate(0 0)",
    fill: "#191bc3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 2.263,
    cy: 2.263,
    r: 2.263,
    transform: "translate(13.238 28.963)",
    fill: "#191bc3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordHide);
export default __webpack_public_path__ + "static/media/password-hide.5bc9787544da6cdd35c8c2b594e01a38.svg";
export { ForwardRef as ReactComponent };